import { render, staticRenderFns } from "./HowItWorksTeacher.vue?vue&type=template&id=01d09f87&lang=pug&"
import script from "./HowItWorksTeacher.vue?vue&type=script&lang=js&"
export * from "./HowItWorksTeacher.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksTeacher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HowItWorksTeacher.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports